import { useTema } from '../contextos/TemaContext';
import { IconoLuna, IconoSol } from './Iconos';

/**
 * Interruptor de tema claro/oscuro.
 *
 * Muestra el icono del tema al que se va a cambiar, no el actual: el botón
 * comunica lo que hará al pulsarlo, que es lo que la persona quiere saber.
 */
export function InterruptorTema() {
  const { tema, alternar, siguiendoAlSistema } = useTema();
  const vaACambiarA = tema === 'dark' ? 'claro' : 'oscuro';

  return (
    <button
      type="button"
      className="btn-icono"
      onClick={alternar}
      title={
        siguiendoAlSistema
          ? `Siguiendo la preferencia del sistema. Cambiar a modo ${vaACambiarA}`
          : `Cambiar a modo ${vaACambiarA}`
      }
      aria-label={`Cambiar a modo ${vaACambiarA}`}
    >
      {tema === 'dark' ? <IconoSol /> : <IconoLuna />}
    </button>
  );
}
